import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
import Price from "../../Price/Price/Price.js";
/* empty css                   */
const priceBaseClassName = "elements-line-item-aside__price";
const LineItemAside = React.forwardRef(
  ({ children, className, currency, discountPrice, price, ...rest }, ref) => {
    const { getLabel } = useIntl();
    let content = children;
    if (discountPrice === 0) {
      content = /* @__PURE__ */ React.createElement("p", { className: `${priceBaseClassName} ${priceBaseClassName}--free` }, /* @__PURE__ */ React.createElement("span", { className: "price" }, getLabel("products.freeProduct")));
    } else if (!children && price) {
      const classNames = classnames(priceBaseClassName, {
        [`${priceBaseClassName}--strikethrough`]: typeof discountPrice === "number"
      });
      content = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", { className: classNames }, /* @__PURE__ */ React.createElement(Price, { value: price, currency })), discountPrice && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement("p", { className: priceBaseClassName }, /* @__PURE__ */ React.createElement(Price, { value: discountPrice, currency, type: "discount" }))));
    }
    return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("elements-line-item-aside", className), ref }, content);
  }
);
LineItemAside.displayName = "LineItemAside";
export {
  LineItemAside as default
};
//# sourceMappingURL=LineItemAside.js.map
